import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-neutral-setzen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeNeutralSetzenEffects {

    AufgabeNeutralSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_NEUTRAL_SETZEN),
        mergeMap((x: ac.PostAufgabeNeutralSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeNeutralSetzen(x.aufgabeBemerkungRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeNeutralSetzenErfolgreichAction(result, x.aufgabeBemerkungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeNeutralSetzenFehlerAction(error, x.aufgabeBemerkungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
